<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import './css/app.scss'
export default {
  name: 'App',
  head() {
    return {
      title: 'Tich',
      script: [
        {
          src: `https://www.google.com/recaptcha/api.js?render=${process.env.VUE_APP_SITEKEY}`,
          async: true,
          defer: true,
        },
      ],
    }
  },
}
</script>
